// extracted by mini-css-extract-plugin
export default {"ncmsContainer":"listaOutrasBases_ncmsContainer__-Tlwb"};